





















import Vue from 'vue'
import libphonenumber from 'google-libphonenumber'

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
export default Vue.extend({
  $_veeValidate: {
    value() {
      return this.value
    },
    name() {
      return this.name
    },
  },
  props: {
    name: {
      type: String,
      default: 'msgsndr1',
    },
    type: {
      default: 'input',
    },
    value: String,
    currentLocationId: String,
    placeholder: String,
    customClass: {
      default: '',
    },
    allowNan: Boolean,
    allowChange: {
      default: false,
    },
    disabled: {
      default: false,
    },
    error: {
      default: false,
    },
    errorMsg: {
      default: '',
    },
  },
  watch: {
    value() {
      if (this.allowChange) this.formattedPhone = this.value
    },
  },
  methods: {
    formatPhoneNumber(phone: string) {
      try {
        if (this.allowNan) {
          let escChar: any = phone.replace(/[-!#$%^&*()+=0-9]/g, '')
          if (isNaN(escChar)) {
            return phone
          }
        }
        const e164 = phoneUtil.format(
          phoneUtil.parse(phone, this.countryCode),
          libphonenumber.PhoneNumberFormat.E164
        )
        return e164
      } catch (err) {
        return phone
      }
    },
    onChange(phone:string) {
      this.$emit('change', this.formatPhoneNumber(phone))
    },
    onBlur(phone:string) {
      this.$emit('blur', this.formatPhoneNumber(phone))
    },
    onKeyup(phone:string) {
      this.$emit('keyup', this.formatPhoneNumber(phone))
    },
    onEnter(phone:string) {
      this.$emit('enter', this.formatPhoneNumber(phone))
    }
  },
  computed: {
    countryCode() {
      if (this.currentLocationId) {
        const location: { [key: string]: any } = this.$store.getters[
          'locations/getById'
        ](this.currentLocationId)
        //console.log(location)
        if (location && location.country) {
          return location.country
        }
      }
      const company: { [key: string]: any } = this.$store.getters['company/get']
      if (company && company.country) {
        return company.country
      }
      return 'US'
    },
    formattedPhone: {
      get: function (): string {
        if (!this.value) return ''
        try {
          if (this.allowNan) {
            let escChar: any = this.value.replace(/[-!#$%^&*()+=0-9]/g, '')
            if (isNaN(escChar)) return this.value
          }
          const parsedNumber = phoneUtil.parse(this.value)
          if (
            phoneUtil.getRegionCodeForNumber(parsedNumber) &&
            phoneUtil.getRegionCodeForNumber(parsedNumber) !== this.countryCode
          ) {
            return phoneUtil.format(
              parsedNumber,
              libphonenumber.PhoneNumberFormat.INTERNATIONAL
            )
          } else if (phoneUtil.getRegionCodeForNumber(parsedNumber)) {
            return phoneUtil.format(
              parsedNumber,
              libphonenumber.PhoneNumberFormat.NATIONAL
            )
          }
          return this.value
        } catch (err) {
          return this.value
        }
      },
      set: function (phone: string) {
        const value = this.formatPhoneNumber(phone)
        this.$emit('input', value)
      },
    },
  },
})
